import type { FaireProductEntity } from "../../entity_types/product";

export const p_pnv3n39s26: FaireProductEntity = {
  token: "p_pnv3n39s26",
  type: "product",
  name: "Casual Valentine Day Heart Jacquard Knit Cardigan",
  brandToken: "b_hrmradn4yd",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b1358e644b3701586b7359aa4f1584ff1b8014661761ee9dbc57445cbe9146d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/def9fef2e2fbc04c4f1648861cf4e5737760c82cf34a8a57a2f4570be9b35069.jpeg",
    "https://cdn.faire.com/fastly/3594a29063f386e7215cb607da168211083802fdc9f7a9f07e80038b2c67ee49.jpeg",
    "https://cdn.faire.com/fastly/becbf8d23c57b8db5929b5c6b17035677b243ef3fa7573d71350fc066de8ca57.jpeg",
    "https://cdn.faire.com/fastly/cfdc2ce9df00a8994d6b1ee24edf11f163270d8238ea38118c7f01ddf98e6ddd.jpeg",
    "https://cdn.faire.com/fastly/58251a33fc6829aecfc5523b52e7586d5d14ebbf87fe73a08350bd31c4b9c8a5.jpeg",
    "https://cdn.faire.com/fastly/b347c16253465646e10b730ff3b6bff8189445517b0637a13711a31647f47b78.png",
  ],
  priceDollars: 35.6,
  description:
    "Celebrate with the EmberLoom Casual Valentine Day Heart Jacquard Knit Cardigan. This cardigan features a heart jacquard pattern, making it a perfect piece for Valentine's Day or any day. Created by Mrwolf, this cardigan represents the EmberLoom commitment to quality and style. Layer it over a blouse or a simple tee.",
  tags: [],
  msrpDollars: 71.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:15.146Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
